import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Globe } from 'lucide-react';

const LanguageToggle = () => {
  const { language, toggleLanguage } = useLanguage();

  return (
    <button 
      onClick={toggleLanguage}
      className="language-toggle"
      title={language === 'fr' ? 'Switch to English' : 'Passer en Français'}
    >
      <Globe className="w-4 h-4" />
      <span>{language === 'fr' ? 'EN' : 'FR'}</span>
    </button>
  );
};

export default LanguageToggle;
